document.addEventListener('DOMContentLoaded', function() {
    const checkboxes = document.querySelectorAll('.variant--quick__add-button input[type="checkbox"]');
  
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(otherCheckbox => {
                if (otherCheckbox !== this) {
                    otherCheckbox.checked = false;
                    const otherParentDiv = otherCheckbox.closest('.variant--quick__add-button');
                    otherParentDiv.classList.remove('checked');
                }
                });
                const parentDiv = this.closest('.variant--quick__add-button');
                parentDiv.classList.add('checked');
            } else {
                const parentDiv = this.closest('.variant--quick__add-button');
                parentDiv.classList.remove('checked');
            }
        });
    });
});